<nz-drawer
  [nzVisible]="visible"
  nzPlacement="bottom"
  [nzClosable]="true"
  [nzHeight]="'auto'"
  [nzMaskClosable]="true"
  (nzOnClose)="close()"
  [nzTitle]="'ADD_TO_CART' | translate"
  class="mobile-cart-bottom-drawer"
>
  <div *nzDrawerContent>
    <div class="mobile-cart-bottom-content p-4">
      <!-- MOQ and Stock Info -->
      <div class="flex items-center justify-between mb-4">
        <div class="flex items-center gap-4">
          <span class="text-sm text-gray-700">
            {{'MOQ' | translate}}: <span class="font-bold">{{getMoq()}}</span>
          </span>
          <div *ngIf="getStockQuantity() !== null && isLogin" class="flex items-center gap-1">
            <span class="text-sm text-gray-700">{{'STOCK' | translate}}:</span>
            <svg-icon
              *ngIf="getStockStatus() === 'available'"
              [iconName]="'new/green.svg'"
              [size]="20"
              [title]="'IN_STOCK' | translate"
            ></svg-icon>
            <svg-icon
              *ngIf="getStockStatus() === 'low'"
              [iconName]="'new/yellow.svg'"
              [size]="20"
              [title]="'LOW_STOCK' | translate"
            ></svg-icon>
            <svg-icon
              *ngIf="getStockStatus() === 'out'"
              [iconName]="'new/red.svg'"
              [size]="20"
              [title]="'OUT_OF_STOCK' | translate"
            ></svg-icon>
          </div>
        </div>
      </div>

      <!-- Quantity Selector -->
      <div class="flex items-center justify-between mb-4">
        <div class="flex items-center gap-2">
          <span class="text-sm text-gray-700 min-w-[60px]">{{'QUANTITY' | translate}}:</span>
          <div class="flex items-center border border-grey rounded">
            <button
              nz-button
              nzType="text"
              nzSize="small"
              class="quantity-btn"
              (click)="decrease()"
              [disabled]="quantity <= getMoq()"
            >
              <i nz-icon nzType="minus" nzTheme="outline"></i>
            </button>
            <input
              type="number"
              class="quantity-input text-center"
              [(ngModel)]="quantity"
              (blur)="quantityBlur($event)"
              [min]="getMoq()"
              [step]="getMoq()"
            />
            <button
              nz-button
              nzType="text"
              nzSize="small"
              class="quantity-btn"
              (click)="increase()"
            >
              <i nz-icon nzType="plus" nzTheme="outline"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Expected Date -->
      <div class="flex items-center justify-between mb-4">
        <span class="text-sm text-gray-700 min-w-[60px]">{{'EXPECT_DATE' | translate}}:</span>
        <div class="flex-1 flex items-center gap-2">
          <nz-date-picker
            *ngIf="quantity > 0"
            [(ngModel)]="expectedDate"
            [nzAllowClear]="false"
            [nzPlaceHolder]="'ADD_DATE' | translate"
            nzFormat="yyyy-MM-dd"
            [nzShowToday]="false"
            [nzDisabledDate]="disabledDate"
            [nzRenderExtraFooter]="footerTemplate"
            class="flex-1"
            style="width: 100%;"
          >
            <ng-template #suffixIcon>
              <svg-icon [isUrl]="false" [iconName]="'date.svg'" [size]="20" class="color-grey"></svg-icon>
            </ng-template>
          </nz-date-picker>
          <ng-template #footerTemplate>
            <div class="text-center py-2">
              <a (click)="chooseDate()" class="text-primaryBlue cursor-pointer">
                {{'ONE_WEEK_LATER' | translate}}
              </a>
            </div>
          </ng-template>
        </div>
      </div>

      <!-- Add to Cart Button -->
      <button
        nz-button
        nzType="primary"
        nzSize="large"
        nzBlock
        class="add-cart-btn"
        [disabled]="!isLogin || userData?.queryUserPageInfoResDTO?.status !== 2 || quantity < getMoq()"
        (click)="addToCart()"
      >
        <svg-icon [isUrl]="false" [iconName]="'cart.svg'" class="mr-2" [size]="20"></svg-icon>
        <span>{{'ADD_TO_CART' | translate}}</span>
      </button>
    </div>
  </div>
</nz-drawer>

